import React, { useState, useEffect } from "react";
import { TextareaAutosize, InputLabel, makeStyles } from "@material-ui/core";
import styles from "../styles";

const useStyles = makeStyles(styles);

const TextArea = (props) => {
  const {
    id,
    label,
    labelIcon,
    name,
    placeholder,
    required,
    initialValue,
    error,
    disabled,
    onChange,
    minLength,
    maxLength,
    rowsMax,
    maxHeight,
  } = props;

  useEffect(() => {
    setValue(initialValue || "");
  }, [initialValue]);

  const inputProps = {};
  if (minLength !== undefined || minLength !== null) {
    inputProps.minLength = minLength;
  }
  if (maxLength !== undefined || maxLength !== null) {
    inputProps.maxLength = maxLength;
  }
  const [value, setValue] = useState(initialValue || "");
  const classes = useStyles();

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange !== undefined && typeof onChange === "function") {
      onChange(e.target.value);
    }
  };

  return (
    <>
      <InputLabel className={classes.inputLabel}>
        {label}
        {required && (
          <span
            aria-hidden="true"
            className="MuiFormLabel-asterisk MuiInputLabel-asterisk"
            style={{ color: "#E30613" }}
          >
            &thinsp;*
          </span>
        )}
        {labelIcon}
      </InputLabel>
      <TextareaAutosize
        name={name}
        id={id}
        size="small"
        margin="dense"
        variant="outlined"
        aria-label="maximum height"
        placeholder={placeholder}
        style={{
          height: 50,
          maxHeight: maxHeight,
          width: "100%",
          marginTop: 8,
        }}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        required={required}
        error={error}
        className={classes.textAreaAuto}
        maxRows={rowsMax || 2}
      />
    </>
  );
};

export default TextArea;
